module.exports = __webpack_public_path__ + "img/inception_annotation_assessment.e8a1e299.svg";